import { ICommonResponse } from '_core/types';

const CommonResponse = ({
  statusCode,
  errorCode,
  errorMessage,
  errorMetadata,
  response,
}: ICommonResponse): Promise<ICommonResponse> => {
  return Promise.resolve({
    statusCode,
    errorCode,
    errorMessage,
    errorMetadata,
    response,
  });
};

export default CommonResponse;
